import { useLayoutEffect } from 'react'

const ROBOTS_NOINDEX = 'noindex, nofollow'

function upsertRobotsMeta(content: string) {
  const selector = 'meta[name="robots"]'
  let element = document.querySelector(selector)

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute('name', 'robots')
    document.head.appendChild(element)
  }

  element.setAttribute('content', content)
}

export function NoIndexMeta() {
  useLayoutEffect(() => {
    const existing = document.querySelector('meta[name="robots"]')
    const previousContent = existing?.getAttribute('content') ?? null

    upsertRobotsMeta(ROBOTS_NOINDEX)

    return () => {
      if (previousContent === null) {
        document.querySelector('meta[name="robots"]')?.remove()
        return
      }
      upsertRobotsMeta(previousContent)
    }
  }, [])

  return null
}
